import script from "./StudentWorkUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentWorkUpload.vue?vue&type=script&setup=true&lang=js"

import "./StudentWorkUpload.vue?vue&type=style&index=0&id=d7a4d2e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7a4d2e8"]])

export default __exports__